import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "231",
  "slug": "gis-lab-to-game-night",
  "title": "A Geography Game Night for a GIS Team",
  "excerpt": "Take turns explaining an unfamiliar satellite image. A suggested format for a GIS team, with room to compare specialist knowledge and mistaken guesses.",
  "date": "2026-03-05",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Put an unfamiliar satellite image on a shared screen and give everyone time to choose a location privately. After the reveal, ask each person to explain one clue they used. A colleague who works with rivers may focus on the drainage pattern; someone who maps transport networks may start with roads."
    },
    {
      "type": "paragraph",
      "text": "This is a suggested activity for a GIS team. You can use a geography game to select locations and keep scores, or prepare a small set of images yourself."
    },
    {
      "type": "heading",
      "text": "Keep the first guess independent"
    },
    {
      "type": "paragraph",
      "text": "Collect guesses before discussing the image. Otherwise one confident explanation can become the whole group's answer before anyone has looked closely."
    },
    {
      "type": "paragraph",
      "text": "Ask people to keep their original notes after the reveal. Compare the clues they actually used with those that only seem obvious once the country name is known."
    },
    {
      "type": "heading",
      "text": "Give different specialties a turn"
    },
    {
      "type": "paragraph",
      "text": "Rotate who begins the discussion. Have that person point to a visible feature and explain how it affected their guess. Invite an alternative interpretation before moving to the next round."
    },
    {
      "type": "paragraph",
      "text": "Familiarity with a land-cover type does not necessarily identify its location. Discuss whether a clue narrows the region or simply describes something that occurs in many places."
    },
    {
      "type": "heading",
      "text": "Add an image review round"
    },
    {
      "type": "paragraph",
      "text": "If you prepare your own images, include the acquisition date and resolution in the answer notes. Reveal those after the guesses and discuss how they affect interpretation. A missing road may be newer than the image; a small stream may be below its resolution."
    },
    {
      "type": "paragraph",
      "text": "Only use images you are allowed to share with the group. Publicly available imagery is a straightforward choice when colleagues work with confidential project data."
    },
    {
      "type": "heading",
      "text": "End with a place worth revisiting"
    },
    {
      "type": "paragraph",
      "text": "Choose one round where the team disagreed. Open a wider view of the location and trace the feature that caused the disagreement. Keep the location in a shared note if someone wants to compare it with a similar landscape later."
    }
  ],
  "tldr": "For a GIS team game night, ask everyone to record a guess before discussing the image. After the reveal, compare which features each person noticed and which interpretations held up."
};
